import { defineStore } from 'pinia';
import { ref } from 'vue';

const useActivityTracker = defineStore('activity-tracker', () => {
  const isActive = ref(false);
  const lastActivityTime = ref(Date.now());
  const currentActivity = ref('');
  const THROTTLE_MS = 30000;
  const isListening = ref(false);

  const tokenIssuedAt = ref(Date.now());

  const trackActivity = (activity: string) => {
    const now = Date.now();
    if (now - lastActivityTime.value < THROTTLE_MS) return;
    isActive.value = true;
    lastActivityTime.value = Date.now();
    currentActivity.value = activity;
  };

  const markTokenRefreshed = () => {
    tokenIssuedAt.value = Date.now();
    lastActivityTime.value = Date.now();
  };

  const handleClick = () => trackActivity('click');
  const handleKeydown = () => trackActivity('keydown');
  const handleMousemove = () => trackActivity('mousemove');
  const handleScroll = () => trackActivity('scroll');

  const listenForActivity = () => {
    if (isListening.value) return;
    isListening.value = true;
    window.addEventListener('click', handleClick);
    window.addEventListener('keydown', handleKeydown);
    window.addEventListener('mousemove', handleMousemove);
    window.addEventListener('scroll', handleScroll);
  };

  const stopListeningForActivity = () => {
    if (!isListening.value) return;
    isListening.value = false;
    window.removeEventListener('click', handleClick);
    window.removeEventListener('keydown', handleKeydown);
    window.removeEventListener('mousemove', handleMousemove);
    window.removeEventListener('scroll', handleScroll);
  };

  return {
    trackActivity,
    listenForActivity,
    stopListeningForActivity,
    isActive,
    lastActivityTime,
    currentActivity,
    tokenIssuedAt,
    markTokenRefreshed,
  };
});

export default useActivityTracker;
